<template>
    <v-layout v-if="ImportResult">
        <v-flex v-if="ImportResult.ImportSuccess == true" class="sprayImportResultTable">
            <v-data-table
                    :headers="headers" 
                    :items="ImportResult.Items"
                    hide-actions>
                    <template slot="items" slot-scope="props">
                        <td>{{props.item.Row}}</td>
                        <td>{{props.item.PlantName}}</td>                        
                        <td>{{props.item.DivisionName}}</td>
                        <td>{{props.item.LocationName}}</td>
                        <td>{{props.item.ProductCategoryName}}</td>
                        <td>{{props.item.Chemical}}</td>
                        <td>{{props.item.SprayDate}}</td>
                        <td>{{props.item.SprayTime}}</td>
                        <td>{{props.item.Result}}</td>
                    </template>
                </v-data-table> 
        </v-flex>
        <v-flex v-else>
            <v-alert type="error" :value="true">{{ImportResult.ErrorMessage}}</v-alert>
        </v-flex>
    </v-layout>
</template>

<script>
export default {
props: ["ImportResult"],
data() {
    return {
        headers: [
            {
                text: "Row",
                value: "Row",
                align: 'left'
            },
            {
                text: "Plant",
                value: "PlantName",
                align: 'left'
            },            
            {
                text: "Division",
                value: "DivisionName",
                align: 'left'
            },
            {
                text: "Location",
                value: "LocationName",
                align: 'left'
            },
            {
                text: "Product",
                value: "ProductCategoryName",
                align: 'left'
            },
            {
                text: "Chemical",
                value: "ChemicalChemical",
                align: 'left',
            },
            {
                text: "Spray Date",
                value: "SprayDate",
                align: 'left'
            },
            {
                text: "Spray Time",
                value: "SprayTime",
                align: 'left'
            },    {
                text: "Result",
                value: "Result",
                align: 'left'
            }
        ]
    }
},
computed: {

},
methods: {

}
}
</script>

<style>
    .sprayImportResultTable {
        max-height: 300px;
        overflow-y: scroll;
    }
</style>
